import { ThemeProvider } from "@carbon6/c6-frontend-design";
import { createBrowserRouter } from "react-router";
import { RouterProvider } from "react-router/dom";
import { appRoutes } from "./router/appRoutes";
import { AppSplash } from "./shell/AppSplash";
import { AppStateProvider } from "./state/AppStateProvider";
import { useThemeModePreference } from "./theme";

const router = createBrowserRouter(appRoutes);

export function AppRoot() {
  const [themeMode] = useThemeModePreference();

  return (
    <ThemeProvider mode={themeMode}>
      <AppStateProvider splash={<AppSplash />}>
        <RouterProvider router={router} />
      </AppStateProvider>
    </ThemeProvider>
  );
}
